import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { completeOnboardingTour } from '../../services';
import { getOnboardingTourStepsQueryKey } from '../keys';

export const useCompleteOnboardingTourMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Record<string, unknown>>({
    async mutationFn() {
      const { data } = await completeOnboardingTour();

      return data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getOnboardingTourStepsQueryKey() });
    },
  });
};
